import React from 'react';
import StepPlaceholder from './StepPlaceholder';

const DebitOrderMandate = () => <StepPlaceholder stepKey="debit-order" />;

export default DebitOrderMandate;
